import React from "react";
import { callApi } from "../../utils/api";
import { BillType } from "./ManageBillType";
import { ToastsStore } from "react-toasts";

declare var $: any;

interface AllProps {
  selectedBillType: BillType;
  listBillType: any;
}

class AddBillType extends React.Component<AllProps> {
  state = {
    billTypeDetail: { id: 0, name: "" },
    isLoading: false,
  };

  componentWillReceiveProps(nextState: AllProps) {
    this.setState({ billTypeDetail: nextState.selectedBillType });
  }

  handleChange = (e: any) => {
    const billTypeDetail: any = { ...this.state.billTypeDetail };
    billTypeDetail[e.target.name] = e.target.value;
    this.setState({ billTypeDetail });
  };

  handleSaveResponse = (response: any) => {
    if (
      response.result === false ||
      (response.message && response.message.indexOf("Already Exist") !== -1)
    ) {
      ToastsStore.error(response.message || "Failed to save Bill Type");
      return;
    }
    this.props.listBillType();
    $("#bill-type-form").modal("hide");
    ToastsStore.success(response.message || "Bill Type saved successfully");
  };

  saveBillType = () => {
    const billTypeDetail = { ...this.state.billTypeDetail };
    billTypeDetail.name = billTypeDetail.name ? billTypeDetail.name.trim() : "";
    if (!billTypeDetail.name) {
      ToastsStore.error("Bill Type name is required");
      return;
    }
    this.setState({ isLoading: true, billTypeDetail });
    if (billTypeDetail.id) {
      billTypeDetail.id = Number(billTypeDetail.id);
      callApi("POST", "bill_type_update.php", billTypeDetail)
        .then((res) => res.data)
        .then((response) => this.handleSaveResponse(response))
        .catch(() => ToastsStore.error("Something went wrong, please try again"))
        .finally(() => this.setState({ isLoading: false }));
    } else {
      callApi("POST", "bill_type_create.php", billTypeDetail)
        .then((res) => res.data)
        .then((response) => this.handleSaveResponse(response))
        .catch(() => ToastsStore.error("Something went wrong, please try again"))
        .finally(() => this.setState({ isLoading: false }));
    }
  };

  render() {
    return (
      <div className="modal fade" id="bill-type-form" role="dialog" aria-hidden="true">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Bill Type Form</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form>
                <div className="form-group">
                  <label className="col-form-label">Bill Type Name:</label>
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    placeholder="Bill Type Name"
                    onChange={this.handleChange}
                    value={this.state.billTypeDetail.name || ""}
                  />
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-dismiss="modal">
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                disabled={this.state.isLoading}
                onClick={this.saveBillType}
              >
                {this.state.isLoading ? (
                  <i className="fa fa-spinner fa-spin" aria-hidden="true" />
                ) : (
                  "Save"
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AddBillType;
